import type { OcrParseResult } from '@container-system/shared';
import { apiRequest } from './client';

export async function parseWeighingDocument(file: File, plantCode: string): Promise<OcrParseResult> {
  const form = new FormData();
  form.append('file', file);
  return apiRequest<OcrParseResult>(`/api/weighings/ocr/parse?plantCode=${encodeURIComponent(plantCode)}`, { method: 'POST', body: form });
}
